import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const GET_PATH = "/api/agent/bank-account/get";
const SAVE_PATH = "/api/agent/bank-account/save";
const UPDATE_PATH = "/api/agent/bank-account/update";

async function sessionHeaders() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("bank_account_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    sessionID: sid,
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
  };
}

/**
 * @returns {Promise<object>}
 */
export async function getBankAccountDetails() {
  const { sessionID, headers } = await sessionHeaders();
  const { data } = await axios.post(
    resolveApiUrl(GET_PATH),
    { sessionID },
    {
      headers,
      withCredentials: true,
      timeout: 25000,
    },
  );
  return data;
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<object>}
 */
export async function saveBankAccountDetails(payload) {
  const { sessionID, headers } = await sessionHeaders();
  const { data } = await axios.post(
    resolveApiUrl(SAVE_PATH),
    { sessionID, ...payload },
    {
      headers,
      withCredentials: true,
      timeout: 25000,
    },
  );
  return data;
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<object>}
 */
export async function updateBankAccountDetails(payload) {
  const { sessionID, headers } = await sessionHeaders();
  const { data } = await axios.post(
    resolveApiUrl(UPDATE_PATH),
    { sessionID, ...payload },
    {
      headers,
      withCredentials: true,
      timeout: 25000,
    },
  );
  return data;
}
